import axios from 'axios/lib/axios';

const base = '/api/v1/content-check/';
const timeout = 30000;

const endpoints = {
  checkPhoto: function (file) {
    return axios.post(
      `${base}photo`,
      {
        params: {
          file: file,
        },
      },
      {
        timeout: timeout,
      }
    );
  },
};

export default endpoints;
